/* Client mirror of FormValidationErrorType in FormValidationError.cs */
export const FORM_VAL_ERR_TYPE = {
    ElementMissing: 0,
    ElementInvalid: 1,
    AutomationFailure: 2
};
